const Profile = () => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/Profile')
const MyAccount = () => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/MyAccount')
const MyAddresses = () => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/MyAddresses')
const PaymentMethods = () => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/PaymentMethods')
const MyOrders = () => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/MyOrders')
const ChangePassword = () => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/ChangePassword')
const OrderInfo = () => import(/* webpackChunkName: "profile" */ '@/modules/order/views/OrderInfo')
const MyDraftOrders =() => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/MyDraftOrders')
const SourcingOrderInfo =() => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/SourcingOrderInfo')

import Auth from '@/services/Auth'

export default [
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    redirect: () => {
      return { name: 'My Account' }
    },
    children: [
      {
        path: 'my-account',
        name: 'My Account',
        component: MyAccount,
        meta: {
          title: 'Account'
        }
      },
      {
        path: 'my-addresses',
        name: 'My Addresses',
        component: MyAddresses,
        beforeEnter: Auth.isLoggedIn,
        meta: {
          title: 'Account'
        }
      },
      {
        path: 'payment-methods',
        name: 'Payment Methods',
        component: PaymentMethods,
        beforeEnter: Auth.isLoggedIn,
        meta: {
          title: 'Account'
        }
      },
      {
        path: 'my-orders',
        name: 'My Orders',
        component: MyOrders,
        meta: {
          title: 'Account'
        }
      },
      {
        path: 'my-orders/draft',
        name: 'My Draft',
        component: MyDraftOrders,
        beforeEnter: Auth.isLoggedIn,
        meta: {
          title: 'Account'
        }
      },
      {
        path: 'change-password',
        name: 'Change Password',
        component: ChangePassword,
        beforeEnter: Auth.isLoggedIn,
        meta: {
          title: 'Account'
        }
      },
      {
        path: 'orders/:id',
        name: 'Order Info',
        component: OrderInfo,
        beforeEnter: Auth.isLoggedIn,
        meta: {
          title: 'Account'
        }
      },
      {
        path: 'sourcing-orders/:id',
        name: 'Sourcing Order Info',
        component: SourcingOrderInfo,
        beforeEnter: Auth.isLoggedIn,
        meta: {
          title: 'Account'
        }
      },
    ]
  },
]
